import { createFileRoute } from "@tanstack/react-router"
import { Observations } from "@/components/project/ProjectDataSheet/Observations"
import z from "zod"

const searchParamSchema = z.object({
  collectionId: z.string().optional(),
})

export const Route = createFileRoute(
  "/_private/projects/$id/data/observations/",
)({
  component: RouteComponent,
  validateSearch: searchParamSchema.parse,
})

function RouteComponent() {
  const navigate = Route.useNavigate()
  const { id } = Route.useParams()
  const { collectionId } = Route.useSearch()
  return (
    <Observations
      collectionId={collectionId}
      onBack={() => navigate({ to: "/projects/$id/data", params: { id } })}
    />
  )
}
